import { ResourceContextProvider, SimpleForm, Title, useNotify, useRefresh, useRedirect } from "react-admin";
import { EmployeeServicePath, BUSINESS_TRIPS, BULGARIA_COUNTRY_ID } from "utils/constants";
import BackButtonToolbar from "features/BackButtonToolbar";
import { useParams } from "react-router";
import { useCallback, useEffect, useState } from "react";
import dataProvider from "server/dataProvider";
import SaveForm from "../SaveForm";
import { employeeRequests } from "api/employeeApi";
import { toTravelersFormValues } from "components/Leaves/Requests/utils/travelers";
import { toBusinessTripPayload } from "components/Leaves/Requests/utils/businessTrip";
import { useNotifyError } from "utils/useNotifyError";

const EditUsers = () => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const { id } = useParams();
  const [defaultValues, setDefaultValues] = useState(null);

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(employeeRequests.getBusinessTripById(id), null, "GET");
      const enrichedLocations = data.locations?.map(loc => ({
        ...loc,
        countryId: loc.countryId ?? BULGARIA_COUNTRY_ID,
      }));
      setDefaultValues({ ...data, locations: enrichedLocations, travelers: toTravelersFormValues(data.travelers) });
    } catch (err) {
      notifyError(err);
    }
  }, [id, notifyError]);

  useEffect(() => {
    if (id) {
      fetchDefaultValues();
    }
  }, [id, fetchDefaultValues]);

  const handleSubmit = async data => {
    try {
      await dataProvider.customRequest(
        employeeRequests.updateBusinessTrip(id),
        toBusinessTripPayload(data),
        "PUT",
      );
      notify("Успешно редактирахте командировката !", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title title={`Редактиране на командировка`} />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${EmployeeServicePath}${BUSINESS_TRIPS}/${id}`}>
        {defaultValues && (
          <SimpleForm
            defaultValues={defaultValues}
            onSubmit={handleSubmit}
          >
            <SaveForm />
          </SimpleForm>
        )}
      </ResourceContextProvider>
    </>
  );
};
export default EditUsers;
